import React from "react";
import { isMobile } from "react-device-detect";
import { ReactComponent as LogoSVG } from "../Gifts/assets/klydo-greet.svg";

interface GreetLogoProps {
  color?: string;
  width?: string;
  style?: React.CSSProperties;
}

const GreetLogo = ({
  color,
  width = isMobile ? "150" : "250",
  style,
}: GreetLogoProps) => {
  return <LogoSVG width={width} style={style} fill={color} />;
};

export default GreetLogo;
